import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MfaService, VerifyTokenRequest } from '@src/app/shared/backend/mfa';
import { firstValueFrom } from 'rxjs';
import { ToasterService } from '@src/app/shared/components/toaster/toaster.service';

@Component({
	selector: 'app-otp-setup',
  standalone: false,
	templateUrl: './otp-setup.component.html',
	styleUrls: ['./otp-setup.component.scss'],
	host: {
		class: 'app-otp-setup'
	}
})
export class OtpSetupComponent implements OnInit {
  qrData: string = '';
  mfaConfigKey: string = '';
  verificationCode: string = '';
  accessToken: string = '';
  verificationError: boolean = false;

  constructor(
    public translate: TranslateService,
    public router: Router,
    private toasterService: ToasterService,
    private mfaService: MfaService
  ) { }

  ngOnInit() {
    this.qrData = sessionStorage.getItem('mfaQrUrl') ?? '';
    this.mfaConfigKey = sessionStorage.getItem('mfaConfigKey') ?? '';
    this.accessToken = sessionStorage.getItem('mfaToken') ?? '';

    if (!this.qrData || !this.mfaConfigKey || !this.accessToken) {
      this.router.navigate(['/login']);
    }
  }

  copyMfaKey() {
    if (!this.mfaConfigKey) return;

    navigator.clipboard.writeText(this.mfaConfigKey).then(() => {
      const toastTitle = this.translate.instant('OTP.COPY_SUCCESS_TITLE');
      const toastMessage = this.translate.instant('OTP.COPY_SUCCESS_MESSAGE');
      this.toasterService.show('success', toastTitle, toastMessage);
    }).catch(err => {
      console.error('Failed to copy MFA key:', err);
    });
  }

  submitOnPressEnter(event: any) {
    if (event.keyCode === 13) {
      this.verify();
    }
  }

  async verify() {
    this.verificationError = false;

    if (!this.verificationCode || !this.accessToken) {
      console.error('Missing verificationCode or accessToken');
      this.verificationError = true;
      return;
    }

    const payload: VerifyTokenRequest = {
      token: this.accessToken,
      userCode: this.verificationCode
    };

    try {
      const mfaVerify = await firstValueFrom(this.mfaService.apiMfaVerifyPost(payload));

      // MFA completed
      if (mfaVerify?.response === 'SUCCESS') {

        // remove Tmp data
        sessionStorage.removeItem('mfaQrUrl');
        sessionStorage.removeItem('mfaConfigKey');
        sessionStorage.removeItem('mfaToken');

        const toastTitle = this.translate.instant('OTP.TOAST_MFA_SUCCESS_TITLE');
        const toastMessage = this.translate.instant('OTP.TOAST_MFA_SUCCESS_MESSAGE');
        this.toasterService.show('success', toastTitle, toastMessage);

        this.router.navigate(['/login']);
      } else {
        console.warn('Unexpected response from MFA verify:', mfaVerify);
        this.verificationError = true;
      }

    } catch (err) {
      console.error('MFA verify error:', err);
      this.verificationError = true;
    }
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }

  ngOnDestroy() {
    // remove tmp data
    sessionStorage.removeItem('mfaQrUrl');
    sessionStorage.removeItem('mfaConfigKey');
    sessionStorage.removeItem('mfaToken');
  }
}
